/**
 * SearchInput — 범용 검색 입력 래퍼 (components/search-input.php).
 *
 * 커스텀 클리어(×) 버튼 동작만 담당:
 *  - input 값이 있으면 × 노출, 비면 숨김([hidden] 토글).
 *  - × 클릭 시 값 삭제 + input 포커스 유지 + input 이벤트 dispatch(값 변화 통지).
 * 폼 제출/필터 자동제출은 건드리지 않는다(× 는 type="button"). 검색 Enter 제출은 폼 기본동작.
 */
export class SearchInput {
    private readonly input: HTMLInputElement;
    private readonly clearBtn: HTMLButtonElement | null;

    constructor(el: HTMLElement) {
        this.input = el.querySelector<HTMLInputElement>("[data-search-input-field]")!;
        this.clearBtn = el.querySelector<HTMLButtonElement>("[data-search-clear]");

        el.dataset.searchInputInited = "1";

        if (!this.input) {
            return;
        }

        this.input.addEventListener("input", () => this.syncClear());

        if (this.clearBtn) {
            this.clearBtn.addEventListener("click", () => this.clear());
        }

        this.syncClear();
    }

    /** 값 유무에 따라 × 버튼 노출 토글. */
    private syncClear(): void {
        if (!this.clearBtn) {
            return;
        }
        this.clearBtn.hidden = this.input.value === "";
    }

    /** 값 삭제 + 포커스 유지 + 변화 통지. */
    private clear(): void {
        this.input.value = "";
        this.input.dispatchEvent(new Event("input", { bubbles: true }));
        this.input.focus();
        this.syncClear();
    }

    static initAll(root: ParentNode = document): void {
        root
            .querySelectorAll<HTMLElement>("[data-search-input]:not([data-search-input-inited])")
            .forEach((el) => new SearchInput(el));
    }
}
